var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-style",attrs:{"id":"app"}},[_c('div',{staticClass:"sticky-top m-0 p-0"},[(_vm.isAuthenticated)?_c('NavBar'):_vm._e()],1),_c('div',[_c('router-view',{key:_vm.$route.fullPath})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }